(() => {
  "use strict";
  const dialog = document.querySelector("#hom-basket");
  if (!dialog) return;
  const config = JSON.parse(
    document.querySelector("#hom-basket-config").textContent,
  );
  const key = "hom-basket-v1",
    money = (n) =>
      new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
      }).format(n / 100);
  const $ = (s) => dialog.querySelector(s),
    el = (tag, text) => {
      const n = document.createElement(tag);
      if (text !== undefined) n.textContent = text;
      return n;
    };
  let basket = { items: [], delivery: "", requestId: "" },
    native = [],
    quote = null,
    serial = 0,
    busy = false,
    retryAvailable = false,
    confirmedDelivery = ""; 
  try {
    const saved = JSON.parse(localStorage.getItem(key));
    if (saved && Array.isArray(saved.items)) basket = saved;
  } catch {}
  if (basket.protocol !== 2) {
    basket.protocol = 2;
    basket.requestId = crypto.randomUUID();
    try {
      localStorage.setItem(key, JSON.stringify(basket));
    } catch {}
  }
  basket.method = basket.method === "pickup" ? "pickup" : "ship";
  const deliveryRulesVersion = "2026-10-21";
  function pickupOnly() {
    return basket.items.some(item => item.pickupOnly === true || ['11336391360855','11336389329239'].includes(String(item.productId)));
  }
  function enforcePickup() {
    if (pickupOnly() && basket.method !== 'pickup') {
      basket.method = 'pickup'; basket.delivery = ''; confirmedDelivery = '';
      dates(configuredDates());
    }
  }
  function needsDeliveryConfirmation() {
    return basket.items.length > 0 && basket.method === "ship";
  }
  function hasValidDate() {
    return !!basket.delivery && $("[data-date]").value === basket.delivery;
  }
  function deliveryConfirmed() {
    return !needsDeliveryConfirmation() ||
      (hasValidDate() && confirmedDelivery === basket.delivery);
  }
  function displayDate() {
    if (!hasValidDate()) return "";
    return new Intl.DateTimeFormat("nl-NL", {
      weekday: "long", day: "numeric", month: "long", year: "numeric"
    }).format(new Date(basket.delivery + "T12:00:00"));
  }
  function renderDeliveryConfirmation() {
    const required = needsDeliveryConfirmation();
    const date = displayDate();
    const checkbox = $("[data-delivery-confirm]");
    $("[data-delivery-rules]").hidden = !required;
    checkbox.disabled = busy || !date;
    checkbox.checked = required && !!date && confirmedDelivery === basket.delivery;
    $("[data-delivery-confirm-label]").textContent = date
      ? config.text.delivery_confirm.replace("{date}", date)
      : config.text.delivery_choose_first;
    const summary = $("[data-chosen-date]");
    summary.hidden = !basket.items.length || !date;
    summary.textContent = date
      ? (basket.method === "pickup" ? config.text.chosen_pickup : config.text.chosen_delivery).replace("{date}", date)
      : "";
    $("[data-confirmation-hint]").hidden = !required || checkbox.checked;
  }
  function message(text, type = "warning", retry = false) {
    retryAvailable = retry;
    $("[data-retry]").hidden = !retryAvailable || busy;
    $("[data-message]").hidden = !text;
    $("[data-message]").dataset.homMessage = type;
    $("[data-message]").textContent = text;
  }
  function save() {
    enforcePickup();
    basket.requestId = crypto.randomUUID();
    localStorage.setItem(key, JSON.stringify(basket));
    quote = null;
    serial++;
    $("[data-checkout]").disabled = true;
    badge();
  }
  function badge() {
    document
      .querySelectorAll(".hom-cart span")
      .forEach(
        (n) =>
          (n.textContent = String(
            basket.items.reduce((s, i) => s + Number(i.quantity), 0) +
              native.reduce((s, i) => s + i.quantity, 0),
          )),
      );
  }
  function configuredDates() {
    const core = window.HomConfiguratorCore;
    return core.deliveryDates(core.amsterdamToday(), config.productionWeeks, config.excludedDates, basket.method);
  }
  function dates(values = []) {
    const select = $("[data-date]");
    select.replaceChildren();
    if (!values.includes(basket.delivery)) {
      basket.delivery = "";
      confirmedDelivery = "";
      const o = el("option", config.text.choose);
      o.value = "";
      select.append(o);
    }
    values.forEach((d) => {
      const o = el(
        "option",
        new Intl.DateTimeFormat("nl-NL", {
          weekday: "long",
          day: "numeric",
          month: "long",
          year: "numeric",
        }).format(new Date(d + "T12:00:00")),
      );
      o.value = d;
      select.append(o);
    });
    select.value = values.includes(basket.delivery) ? basket.delivery : "";
    select.dispatchEvent(new Event("hom:dates"));
  }
  async function nativeCart() {
    const r = await fetch((window.Shopify?.routes?.root || "/") + "cart.js", {
      cache: "no-store",
    });
    if (!r.ok) throw Error(config.text.unavailable);
    const c = await r.json();
    native = c.items || [];
    badge();
  }
  async function changeNative(lineKey, quantity) {
    if (busy) return;
    busy = true;
    quote = null;
    serial++;
    render();
    message("");
    try {
      const response = await fetch((window.Shopify?.routes?.root || "/") + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: lineKey, quantity }),
      });
      const data = await response.json();
      if (!response.ok) throw Error(data.description || data.message || config.text.unavailable);
      native = data.items || [];
      save();
      busy = false;
      await check();
    } catch (error) {
      message(error.message, "error");
    } finally {
      busy = false;
      render();
    }
  }
  function render() {
    enforcePickup();
    const list = $("[data-lines]");
    list.replaceChildren();
    basket.items.forEach((item, index) => {
      const row = el("article");
      row.className = "hb-line";
      row.append(
        el("h3", item.title),
        el(
          "p",
          `${item.length} × ${item.depth} × ${item.thickness} mm · ${item.edgeLabel || (item.edges === "rounded" ? config.text.rounded : config.text.straight)}${item.finishLabel ? " · " + item.finishLabel : ""}${item.skewLeft || item.skewRight ? ` · Achterzijde links ${item.skewLeft} mm / rechts ${item.skewRight} mm (+ buiten, − binnen)` : ""}`,
        ),
      );
      if (Number(item.fingerJointCount) > 0)
        row.append(el("p", "Je plank krijgt zichtbare, verspringende vingerlassen in de lengterichting."));
      if (item.isFloating) {
        const supports = [item.wallLeft ? "links" : "", item.wallRight ? "rechts" : ""].filter(Boolean);
        if (supports.length) row.append(el("p", "Zijdrager: " + supports.join(" en ")));
        if (item.roundedCorners?.length)
          row.append(el("p", item.roundedCorners.length + " afgeronde hoek(en)"));
      }
      if (item.kind === "niche" && Number(item.rearSupportCount) > 0 && item.rearSupportName)
        row.append(el("p", config.text.supports_per_plank
          .replace("{count}", String(item.rearSupportCount))
          .replace("{name}", item.rearSupportName)
          .replace("{brackets}", Number(item.rearBracketCount) > 0
            ? config.text.support_brackets.replace("{count}", String(item.rearBracketCount)) : "")));
      const label = el("label", config.text.quantity + " "),
        input = el("input");
      input.type = "number";
      input.min = 1;
      input.max = 50;
      input.value = item.quantity;
      input.disabled = busy;
      input.setAttribute("aria-label", config.text.quantity + " " + item.title);
      input.addEventListener("change", () => {
        if (
          !Number.isInteger(Number(input.value)) ||
          +input.value < 1 ||
          +input.value > 50
        ) {
          input.value = item.quantity;
          return;
        }
        item.quantity = +input.value;
        changed();
      });
      label.className = "hb-quantity";
      label.append(input);
      row.append(
        label,
        el(
          "strong",
          money(
            (quote?.lines[index]?.unitCents ?? item.unitCents) * item.quantity,
          ),
        ),
      );
      if (item.lighting === "yes")
        row.append(el("p", item.lightingLabel || "Verlichting"));
      const components = quote?.lines[index]?.components || item.components;
      if (components?.length) {
        const parts = el("div");
        parts.className = "hb-components";
        parts.append(
          el("p", "Inbegrepen accessoires · apart via PostNL"),
        );
        components.forEach((part) => {
          const line = el("div");
          line.className = "hb-component";
          line.append(
            el("span", part.quantity * item.quantity + " × " + part.title),
            el("strong", money(part.cents * part.quantity * item.quantity)),
          );
          parts.append(line);
        });
        row.append(parts);
      }
      const remove = el("button", config.text.remove);
      remove.type = "button";
      remove.disabled = busy;
      remove.addEventListener("click", () => {
        basket.items.splice(index, 1);
        changed();
      });
      remove.className = "hb-remove";
      row.append(remove);
      list.append(row);
    });
    native.forEach((item, index) => {
      const row = el("article");
      row.className = "hb-line";
      row.append(el("h3", item.product_title));
      if (item.variant_title && item.variant_title !== "Default Title")
        row.append(el("p", item.variant_title));
      for (const [name, value] of Object.entries(item.properties || {})) {
        if (!name.startsWith("_") && value) row.append(el("p", name + ": " + value));
      }
      const label = el("label", config.text.quantity + " ");
      label.className = "hb-quantity";
      const input = el("input");
      input.type = "number";
      input.min = 1;
      input.max = 100;
      input.value = item.quantity;
      input.disabled = busy;
      input.setAttribute("aria-label", config.text.quantity + " " + item.product_title);
      input.addEventListener("change", () => {
        const quantity = Number(input.value);
        if (!Number.isInteger(quantity) || quantity < 1 || quantity > 100) {
          input.value = item.quantity;
          return;
        }
        changeNative(item.key, quantity);
      });
      label.append(input);
      const remove = el("button", config.text.remove);
      remove.type = "button";
      remove.className = "hb-remove";
      remove.disabled = busy;
      remove.setAttribute("aria-label", config.text.remove + " " + item.product_title);
      remove.addEventListener("click", () => changeNative(item.key, 0));
      row.append(label, el("strong", money(
        quote?.lines[basket.items.length + index]?.totalCents ?? item.final_line_price
      )), remove);
      list.append(row);
    });
    if (!basket.items.length && !native.length)
      list.append(el("p", config.text.empty));
    $("[data-method]").value = basket.method;
    $("[data-method]").disabled = busy || pickupOnly();
    $("[data-date-title]").textContent =
      basket.method === "pickup"
        ? config.text.pickup_date
        : config.text.delivery;
    $("[data-method-note]").textContent =
      basket.method === "pickup"
        ? (pickupOnly() ? config.text.pickup_only + " " : "") + config.text.pickup_note
        : config.text.ship_note;
    $("[data-shipping-title]").textContent =
      quote?.shipping?.title || config.text.shipping_cost;
    $("[data-shipping-cost]").textContent = quote
      ? money(quote.shipping.grossCents)
      : basket.items.length ? config.text.pending_shipping : "Bij afrekenen berekend";
    $("[data-grand-total]").textContent = quote
      ? money(quote.grandTotalCents)
      : basket.items.length ? "—" : money(native.reduce((sum, item) => sum + item.final_line_price, 0)) + " + verzending";
    $("[data-total]").textContent = money(
      quote?.totalCents ??
        basket.items.reduce((s, i) => s + i.unitCents * i.quantity, 0) +
          native.reduce((s, i) => s + i.final_line_price, 0),
    );
    $("[data-date]").disabled = busy || !basket.items.length;
    renderDeliveryConfirmation();
    $("[data-checkout]").disabled = busy || (basket.items.length ? !quote || !hasValidDate() || !deliveryConfirmed() : !native.length);
    if ($("[data-fulfilment]")) $("[data-fulfilment]").hidden = !basket.items.length;
    $("[data-test]").hidden = !quote?.testMode;
    $("[data-retry]").hidden = !retryAvailable || busy;
    badge();
  }
  function payload(action) {
    return {
      action,
      pricingThemeId: config.pricingThemeId,
      items: basket.items.map((item) =>
        Object.fromEntries(
          [
            "skewLeft",
            "skewRight",
            "isFloating",
            "wallLeft",
            "wallRight",
            "roundedCorners",
            "cornerRadius",
            "customRearPositions",
            "sideEdgeLeft",
            "sideEdgeRight",
            "productId",
            "length",
            "depth",
            "thickness",
            "quantity",
            "edges",
            "kind",
            "finish",
            "lighting",
            "lightingType",
            "lightingControl",
            "spotColour",
            "spots",
            "strip",
            "transformerLocation",
            "electricalPoint",
            "cableDirection",
          ]
            .filter((key) => item[key] !== undefined)
            .map((key) => [key, item[key]]),
        ),
      ),
      native: native.map((i) => ({
        variantId: String(i.variant_id),
        quantity: i.quantity,
        properties: i.properties,
        sellingPlan: !!i.selling_plan_allocation,
      })),
      deliveryConfirmation: needsDeliveryConfirmation() && deliveryConfirmed()
        ? { accepted: true, date: basket.delivery, rulesVersion: deliveryRulesVersion }
        : null,
      delivery: basket.delivery,
      method: basket.method,
      country: "NL",
      protocol: 2,
      quote: quote?.quote,
      requestId: basket.requestId,
    };
  }
  async function api(body) {
    let r;
    try {
      r = await fetch(config.endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        signal: AbortSignal.timeout(60000),
      });
    } catch {
      throw Error(config.text.unavailable);
    }
    let data;
    try {
      data = await r.json();
    } catch {
      throw Error(config.text.unavailable);
    }
    if (data.protocol !== 2) throw Error(config.text.backend_update);
    if (!r.ok) {
      const e = Error(data.error || config.text.unavailable);
      e.dates = data.dates;
      throw e;
    }
    return data;
  }
  async function check() {
    if (busy) return;
    const version = ++serial;
    message("");
    quote = null;
    render();
    if (!basket.items.length) {
      try { await nativeCart(); render(); message(native.length ? "" : config.text.empty); }
      catch (error) { message(error.message, "error", true); }
      return;
    }
    message("");
    try {
      await nativeCart();
      if (version !== serial) return;
      const server = await api({action:"capabilities", protocol:2, method:basket.method});
      const required = new Set(['wood_tiers','raw_thickness_40_52']);
      for (const item of basket.items) {
        if (item.kind === 'niche') required.add('niche');
        if (item.isFloating) required.add('floating');
        if (item.lighting === 'yes') required.add('lighting');
        if (item.customRearPositions) required.add('custom_supports');
        if (['toiletplank','kastblad','kastplank'].includes(item.kind)) {
          required.add(item.kind); required.add('product_bound_wood');
        }
        if (item.lightingType === 'own-strip' && item.strip?.mode === 'full' && item.transformerLocation === 'external') required.add('full_strip_external');
      }
      if (pickupOnly()) required.add('pickup_only');
      if ([...required].some(feature => !server.capabilities?.includes(feature))) throw Error(config.text.backend_update);
      if (version !== serial) return;
      const result = await api(payload("quote"));
      if (version !== serial) return;
      if (result.protocol !== 2 || !result.shipping)
        throw Error(config.text.backend_update);
      quote = result;
      dates(result.dates);
      message("");
      render();
    } catch (e) {
      if (version !== serial) return;
      if (e.dates) dates(e.dates);
      message(e.message, "error", !e.dates);
      render();
    }
  }
  function changed() {
    if (busy) return;
    try {
      save();
      render();
      check();
    } catch {
      message(config.text.storage, "error");
    }
  }
  async function open() {
    if (!dialog.open) {
      dialog.showModal();
      document.documentElement.classList.add("hom-basket-open");
    }
    dates(configuredDates());
    render();
    await check();
  }
  window.HomCart = {
    add(item) {
      if (busy) throw Error(config.text.checking);
      if (basket.items.length >= 30) throw Error(config.text.limit);
      basket.items.push(item);
      try {
        save();
      } catch {
        basket.items.pop();
        throw Error(config.text.storage);
      }
      open();
    },
    open,
  };
  $("[data-method]").addEventListener("change", (e) => {
    confirmedDelivery = "";
    basket.method = e.target.value;
    basket.delivery = "";
    dates(configuredDates());
    changed();
  });
  dialog.addEventListener("close", () => {
    document.documentElement.classList.remove("hom-basket-open");
    if (location.pathname.endsWith("/cart"))
      location.assign(window.Shopify?.routes?.root || "/");
  });
  dialog.addEventListener("click", (e) => {
    if (e.target === dialog) {
      const r = dialog.getBoundingClientRect();
      if (
        e.clientX < r.left ||
        e.clientX > r.right ||
        e.clientY < r.top ||
        e.clientY > r.bottom
      )
        dialog.close();
    }
  });
  $("[data-close]").addEventListener("click", () => dialog.close());
  $("[data-continue]").addEventListener("click", () => dialog.close());
  $("[data-retry]").addEventListener("click", () => check());
  $("[data-date]").addEventListener("change", (e) => {
    confirmedDelivery = "";
    basket.delivery = e.target.value;
    changed();
  });
  $("[data-delivery-confirm]").addEventListener("change", (e) => {
    confirmedDelivery = e.target.checked && hasValidDate() ? basket.delivery : "";
    render();
  });
  $("[data-checkout]").addEventListener("click", async () => {
    if (busy) return;
    if (!basket.items.length && native.length) {
      location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
      return;
    }
    if (!quote || !hasValidDate()) return;
    if (!deliveryConfirmed()) {
      message(config.text.delivery_confirm_required);
      $("[data-delivery-confirm]").focus();
      return;
    }
    busy = true;
    serial++;
    render();
    message(config.text.opening);
    try {
      const before = JSON.stringify(payload("quote").native);
      await nativeCart();
      if (before !== JSON.stringify(payload("quote").native))
        throw Error(config.text.changed);
      const result = await api(payload("checkout"));
      const url = new URL(result.checkoutUrl);
      if (
        url.protocol !== "https:" ||
        !["studio.houtopmaat.nl", "7inpk6-1e.myshopify.com"].includes(
          url.hostname,
        )
      )
        throw Error(config.text.unavailable);
      location.assign(url.href);
    } catch (e) {
      quote = null;
      message(e.message, "error", true);
    } finally {
      busy = false;
      render();
    }
  });
  document.addEventListener("click", (e) => {
    const a = e.target.closest('a[href]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === "_blank") return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin || !(url.pathname.endsWith("/cart") || url.pathname.endsWith("/cart/"))) return;
    if (a) {
      e.preventDefault();
      open();
    }
  });
  window.addEventListener("storage", (e) => {
    if (e.key === key) {
      confirmedDelivery = "";
      try {
        const next = JSON.parse(e.newValue);
        basket =
          next && Array.isArray(next.items)
            ? next
            : { items: [], delivery: "", requestId: "" };
        basket.method = basket.method === "pickup" ? "pickup" : "ship";
        quote = null;
        serial++;
        badge();
        if (dialog.open) check();
      } catch {}
    }
  });
  // Standard Shopify additions use the same basket presentation.
  document.addEventListener("cart:update", (event) => {
    if (event.detail?.data?.didError || busy) return;
    if (event.detail?.data?.source === "product-form-component") open();
    else if (dialog.open) check();
    else nativeCart().catch(() => {});
  });
  nativeCart().catch(() => {});
  if (
    location.pathname.endsWith("/cart")
  )
    open();
})();





